export default "__VITE_ASSET__BvlqOdeS__"